export interface ISpecial {
  id: string;
  firstname: string;
  lastname: string;
  name: string;
  login: string;
  avatar: string;
  type: string;
  password: string;
  session_id: string;
}

export const levelType = {
  moderator: 'M',
  guest: 'S',
  powerUser: 'U',
  journalist: 'J',
  premoderator: 'P',
  videoOperator: 'O'
};



// WEBPACK FOOTER //
// ./src/app/models/special.ts